import { render, staticRenderFns } from "./Sci.vue?vue&type=template&id=03dab1e6"
import script from "./Sci.vue?vue&type=script&lang=js"
export * from "./Sci.vue?vue&type=script&lang=js"
import style0 from "./Sci.vue?vue&type=style&index=0&id=03dab1e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports